


































































import Vue from "vue";
import FilterBar from "@/components/filter/KommunenFilter.vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import LoadingScreen from "@/components/dialog/LoadingScreen.vue";
import DataTable, { Header } from "@/components/table";

import { alertError } from "@/services/ErrorAlert";
import { kommunenServiceInstance } from "@/services/KommunenService";
import UserService from "@/services/UserSerivce";
import { RequestError } from "@/services/AuthService";
import AlertService from "@/services/libs/AlertService";
import GdaClient from "@/assets/gda/gda_client_api";
import fileDownload from "js-file-download";

import { OverviewKommune, KommunenFilter } from "@/types/Kommune";
import { Page } from "@/types/Page";
import StorageService from "@/services/libs/StorageService";

export default Vue.extend({
  name: "KommunenMain",
  metaInfo: {
    title: "Kommunen",
  },
  components: {
    FilterBar,
    Fieldset,
    DataTable,
    LoadingScreen,
  },
  data: function () {
    return {
      editable: false,
      isExporting: false,
      tablekey: 0,
      tabelOptions: {
        customColumns: true,
        page: 0,
      },
      filter: {} as KommunenFilter,
      tableHeader: [
        {
          label: "VG/Stadt",
          field: "wohnplatzBez",
          sortable: true,
        },
        {
          label: "Konzepte",
          field: "einzelkonzeptAnzahl",
          sortable: true,
        },
        {
          label: "Maßnahmen",
          field: "massnahmenAnzahl",
          sortable: true,
        },
        {
          label: "Nächster Termin",
          field: "terminDatum",
          type: "date",
          sortable: true,
        },
        {
          label: "Geändert",
          field: "geaendertAm",
          type: "date",
          sortable: true,
        },
      ] as Header[],
    };
  },
  beforeMount() {
    if (UserService.hasWritePermission()) {
      // has read and write permission
      this.editable = true;
    }
    this.tabelOptions = StorageService.get("kommunenTableOptions") || {
      customColumns: true,
      page: 0,
      size: 10,
      sort: "",
      sortOrder: "asc",
    };
    this.filter = StorageService.get("KommunenFilter") || {};
  },
  methods: {
    onFilterSubmit(filter: KommunenFilter) {
      this.filter = filter;
      StorageService.set("kommunenTableOptions", null);
      this.tabelOptions.page = 0;
      this.tablekey++;
      //(this.$refs.dataTable as any).loadContent();
    },
    /** load event to load data */
    loadData(
      page: number,
      size: number,
      sort: string,
      ascending: boolean,
    ): Promise<{ rows: any[]; total: number }> {
      let kommunenTableOptions =
        StorageService.get("kommunenTableOptions") || this.tabelOptions;
      kommunenTableOptions.page = page;
      kommunenTableOptions.size = size;
      kommunenTableOptions.sort = sort;
      kommunenTableOptions.sortOrder = ascending ? "asc" : "desc";

      StorageService.set("kommunenTableOptions", kommunenTableOptions);
      return kommunenServiceInstance
        .getPage(page, size, sort, ascending, this.filter)
        .then((page: Page<OverviewKommune>) => ({
          rows: page.content,
          total: page.totalElements,
        }))
        .catch((error: any) => {
          alertError(error);
          return { rows: [], total: 0 };
        });
    },
    onExport() {
      this.isExporting = true;
      kommunenServiceInstance
        .getExport(this.filter)
        .then((res: any) => {
          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileDownload(blob, "ihsm_export.xlsx");
        })
        .catch((error: RequestError) => {
          AlertService.error(
            "Beim Herunterladen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          );
        })
        .finally(() => (this.isExporting = false));
    },
    onClick(item: any, editMode: boolean) {
      this.$router.push({
        name: "KommunenDetail",
        params: { id: item.id },
        query: editMode ? { editMode: "true" } : {},
      });
    },
    onOpenGda(item: OverviewKommune) {
      // opens the maßnahme location in the gda application by using the gda client

      let bbox = JSON.parse(item.bbox);
      if (bbox) {
        let mybox = [];
        mybox[0] = bbox.coordinates[0][0][0];
        mybox[1] = bbox.coordinates[0][1][1];
        mybox[2] = bbox.coordinates[0][2][0];
        mybox[3] = bbox.coordinates[0][2][1];

        ((this as any).$gdaClient as GdaClient).zoomKarte(mybox, 1);

        ((this as any).$gdaClient as GdaClient).filterObjektOnLayer(
          "G_VERBANDSGEMEINDEN",
          "GEMEINDE_NR",
          [String(item.gemeindeNr)],
        );
      }
    },
  },
});
